import React, { useState } from "react"
import { MdAutoFixHigh, MdCheckCircleOutline, MdHealthAndSafety } from "react-icons/md"
import Modal from "../index"
import Button from "../../Form/Button"
import FormGroup from "../../Form/FormGroup"
import Textarea from "../../Form/Textarea"
import Checkbox from "../../Form/Checkbox"
import api from "../../../services/api"
import Loading from "../../../pages/layouts/Loading"
import { toast } from "react-toastify"
import styles from "./agentReview.module.css"

const SECTION_LABELS = { identity: "Identidade", conversation_start: "Boas-vindas", brain: "Comportamento e intenções", guardrails: "Segurança", handoff: "Atendimento humano", follow_up: "Retomar conversa", settings: "Atendimento humano" }
const QUICK_REVIEWS = [
    "Fazer uma revisão geral",
    "O agente repete perguntas",
    "As intenções estão sendo confundidas",
    "As respostas estão pouco naturais"
]

const ModalAgentReview = ({ agent, closeModal, onApply }) => {
    const [feedback, setFeedback] = useState("")
    const [review, setReview] = useState(null)
    const [selected, setSelected] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const analyze = async () => {
        try {
            setIsLoading(true)
            const response = await api.post(`/ai/agents/${agent._id}/review`, { feedback })
            const value = response.data?.data
            setReview(value)
            setSelected((value?.suggestions || []).map(item => item.id))
        } catch (error) {
            toast.error(error?.response?.data?.message || "Não foi possível analisar o agente.")
        } finally { setIsLoading(false) }
    }

    const toggle = id => setSelected(previous => previous.includes(id) ? previous.filter(item => item !== id) : [...previous, id])

    return <Modal icon={<MdAutoFixHigh />} title="Assistente de melhoria" description={`${agent.name} • versão ${agent.version || 1}`} closeModal={closeModal} heightFitContent bodyClassName={styles.modalBody}>
        <div className={styles.content}>
            {!review ? <section className={styles.intro}>
                <div className={styles.explanation}><MdHealthAndSafety /><div><strong>Melhore o agente sem perder a configuração atual</strong><span>O assistente identifica inconsistências e prepara mudanças para você revisar. Nada é alterado automaticamente.</span></div></div>
                <div className={styles.howItWorks}>
                    <div><span>1</span><p><strong>Explique o problema</strong><small>Ou escolha uma revisão geral.</small></p></div>
                    <div><span>2</span><p><strong>Confira o diagnóstico</strong><small>A IA avalia cada seção.</small></p></div>
                    <div><span>3</span><p><strong>Aceite as melhorias</strong><small>Uma nova versão será criada.</small></p></div>
                </div>
                <FormGroup labelText="O que você quer melhorar? (opcional)"><Textarea rows={5} maxLength={2000} value={feedback} onChange={event => setFeedback(event.target.value)} placeholder="Ex: o agente volta a pedir o nome depois de o lead já ter informado..." /><small>{feedback.length}/2000</small></FormGroup>
                <div className={styles.quickReviews}><span>Atalhos</span><div>{QUICK_REVIEWS.map(option => <Button key={option} type="button" size="sm" variant="neutral" className={styles.quickReview} onClick={() => setFeedback(option)}>{option}</Button>)}</div></div>
            </section> : <>
                <header className={styles.resultHeader}><div className={styles.score}><strong>{review.score}</strong><span>/100</span></div><div><strong>Diagnóstico da configuração</strong><p>{review.summary}</p></div></header>
                {!!review.strengths?.length && <div className={styles.strengths}><strong><MdCheckCircleOutline /> Pontos positivos</strong><span>{review.strengths.join(" • ")}</span></div>}
                <section className={styles.suggestions}>
                    <div className={styles.suggestionsTitle}><div><strong>Sugestões disponíveis</strong><span>Selecione o que a IA deve aplicar na nova versão.</span></div><small>{selected.length} selecionada(s)</small></div>
                    {review.suggestions?.length ? review.suggestions.map(item => <Button type="button" variant="neutral" key={item.id} aria-pressed={selected.includes(item.id)} className={`${styles.suggestion} ${selected.includes(item.id) ? styles.selected : ""}`} onClick={() => toggle(item.id)}>
                        <Checkbox checked={selected.includes(item.id)} />
                        <div>
                            <span className={styles.sectionBadge}>{SECTION_LABELS[item.section] || "Configuração do agente"}</span>
                            <strong>{item.title}</strong>
                            <p>{item.problem}</p>
                            <small>{item.improvement}</small>
                            {!!item.changes?.length && <span className={styles.appliedChanges}><b>O que será alterado</b>{item.changes.join(", ")}</span>}
                        </div>
                    </Button>) : <div className={styles.empty}>A configuração não apresentou melhorias seguras para aplicação automática.</div>}
                </section>
            </>}
        </div>
        <footer className={styles.actions}>
            <Button variant="secondary" onClick={review ? () => setReview(null) : closeModal}>{review ? "Refazer análise" : "Cancelar"}</Button>
            {!review ? <Button variant="primary" onClick={analyze} disabled={isLoading}>{isLoading ? "Analisando..." : "Iniciar análise"}</Button> : <Button variant="primary" onClick={() => onApply(review, selected)} disabled={!selected.length || isLoading}>Aplicar e criar nova versão</Button>}
        </footer>
        {isLoading && <Loading fullPage />}
    </Modal>
}

export default ModalAgentReview
